import { Suspense } from "react";
import { lazyWithRetry } from "@circle-react/helpers/lazyRetry";
import { PageLoader } from "@circle-react/pages/PageLoader";

const PagesComponent = lazyWithRetry(
  () =>
    import(
      /* webpackChunkName: "PageBuilderEdit" */ "@circle-react/components/SettingsApp/Site/Pages/Edit"
    ),
);

export const EditPage = () => (
  <Suspense fallback={<PageLoader />}>
    <PagesComponent />
  </Suspense>
);
